// extracted by mini-css-extract-plugin
export default {"shadowNav":"styles__shadowNav--3D321","centredScreen":"styles__centredScreen--1e8tn","leftScreen":"styles__leftScreen--3Tk1D","rightScreen":"styles__rightScreen--5ftKG"};